<template>

    <form v-on:submit="Save">
        <div class="card card-info">

            <div class="card-header">
                <h3 class="card-title">Manage</h3>
            </div>
            <!-- /.card-header -->
            <!-- form start -->

            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <label>Job Campaign</label>
                        <select class="form-control" v-model="offering.JobCampaignID" required>
                            <option>--select--</option>
                            <option v-for="item in jobCampaigns" :value="item.JobCampaignID">{{item.Name}}</option>
                        </select>
                    </div>
                    <div class="col-md-12">
                        <label>Job Title</label>
                        <input class="form-control" v-model="offering.JobTitle" required />
                    </div>
                    <div class="col-md-12" style="padding-bottom: 75px">
                        <div class="form-group">
                            <label>Description </label>
                            <quill-editor v-model="offering.Description" required />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label>Last Date</label>
                        <input v-model="offering.LastDate" type="date" class="form-control" required />
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-md-12">
                    <button class="btn btn-success" type="submit" style="margin-top: 20px;float:right">Save</button>
                    <button class="btn btn-primary" v-on:click="back()" type="button" style="margin-top: 20px;float:left">Back to list</button>
                </div>
            </div>
        </div>

    </form>
</template>

<script>const axios = require('axios').default;
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'
    export default ({
        components: {
            quillEditor
        },
        data() {
            return {
                offering: { JobCampaignID: '', JobTitle: '', Description: '', LastDate: '' },
                jobCampaigns: [],
            }
        },

        created: function () {
            this.pageLoad();
        },

        mounted: function () {
        },

        updated: function () {
        },

        methods: {

            pageLoad() {
                var vm = this;
                axios.post('/ApplicantsApi/pageLoadJobOffereing')
                    .then(function (res) {
                        if (res.data.status) {
                            vm.jobCampaigns = res.data.jobCampaigns;
                            if (res.data.offering)
                                vm.offering = res.data.offering;
                        }
                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            Save(e) {
                e.preventDefault();
                startReq();

                var vm = this;
                axios.post('/ApplicantsApi/saveJobOffering', {
                    offering: vm.offering,
                })
                    .then(function (res) {
                        if (res.data.status) {
                            toastr.success("Data Saved Successfully");
                            setTimeout(function () { window.location.reload() }, 2000);
                        }
                        else {
                            endReq();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            back() {
                window.location.href = "../Jobs/JobOfferingIndex";
            }
        }
    })</script>

<style>
    table thead tr th {
        background-color: #605ca8;
        color: white;
    }

    blink {
        -webkit-animation: 2s linear infinite condemned_blink_effect;
    }

    @-webkit-keyframes condemned_blink_effect {

        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }

    @keyframes condemned_blink_effect {
        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/jobOffering.vue